import React, {ChangeEvent, FormEvent, useEffect, useState} from "react";
import Form from "../../../../components/common/form/Form";
import InputField from "../../../../components/common/form/InputField";
import {OptionType} from "../../../../helpers/utils/StyleUtils";
import {useNavigate, useParams} from "react-router-dom";
import ButtonTray from "../../../../components/common/form/ButtonTray";
import {Routes as AppRoutes} from "../../../../routes";
import {handleRTKQuery} from "../../../../helpers/utils/RtkQueryUtils";
import {useCreateStateCodeMutation, useGetStateCodeByIdQuery} from "../stateCodeApi";
import Breadcrumb from "../../../../components/common/Breadcrumbs";

const CreateStateCodes = () => {
    const {codeId} = useParams();
    const [stateCodes, setStatecodes] = useState<any>({});

    const {data: stateCodeData} = useGetStateCodeByIdQuery(codeId);
    const [createStateCodeApi, createStateCodeApiResponse] = useCreateStateCodeMutation()

    const navigate = useNavigate();
    const [crumbs] = useState([
        {content: "Home", url: "/"},
        {content: "State Codes", url: "/state-codes"},
        {content: "Add State Code", url: ""},
    ]);

    useEffect(() => {
        if (stateCodeData) {
            setStatecodes({
                ...(stateCodeData)
            });
        }
    }, [stateCodeData]);

    const handleOnChange = (e: ChangeEvent<HTMLInputElement> | { name: string; value: OptionType | null }) => {
        const {name, value} = "target" in e ? e.target : e;
        setStatecodes((prevData: any) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        let obj = {
            ...stateCodes,
        }
        const UpdateSystemProperty = async () => {
            return await createStateCodeApi(obj).unwrap();
        };
        await handleRTKQuery(UpdateSystemProperty, (response: any) => {
            if (response?.success || response?.data?.success) {
                navigate(AppRoutes.StateCode.path);
            }
        });
    }

    return (
        <>
            <div className="px-4 py-2 ">
                <div className={"justify-between sm:block md:flex lg:flex"}>
                    <Breadcrumb crumbs={crumbs}/>
                </div>
                <div className="flex justify-center mt-3">
                    <div className="bg-text-0 lg:w-4/6 sm:w-full p-5 rounded-md shadow-[0_0_10px_-2px_rgba(0,0,0,0.2)]">
                        <h3 className="text-xl font-semibold text-surface-0 pb-3 border-b border-surface-7">Add State
                            Code</h3>
                        <Form
                            onSubmit={handleSubmit}
                            fields={
                                <>
                                    <div className="grid grid-cols-12 mt-5">
                                        <InputField
                                            name="name"
                                            label="Name"
                                            value={stateCodes?.name || ""}
                                            onChange={handleOnChange}
                                            required
                                            placeholder="Enter Name..."
                                        />
                                    </div>
                                    <div className="col-span-12 md:grid md:grid-cols-12 gap-3">
                                        <div className="col-span-3 sm:mt-2 lg:mt-0 mt-2 flex items-center">
                                        </div>
                                        <div className="relative col-span-9">
                                            <div className={"mt-4 flex"}>
                                                <ButtonTray
                                                    buttons={[
                                                        {
                                                            buttonProps: {
                                                                btnText: "Cancel",
                                                                onClick: () => navigate(AppRoutes.StateCode.path),
                                                                type: "close",
                                                            },
                                                            buttonType: "button"
                                                        },
                                                        {
                                                            buttonProps: {
                                                                btnText: "Add",
                                                                type: "submit",
                                                                isLoading: (createStateCodeApiResponse.isLoading),
                                                            },
                                                            buttonType: "button",
                                                        }
                                                    ]}
                                                    align="center"
                                                    gap={2}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </>
                            }
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

export default CreateStateCodes;